import { render } from "./CartDropdown.vue?vue&type=template&id=b03a9070&scoped=true"
import script from "./CartDropdown.vue?vue&type=script&lang=js"
export * from "./CartDropdown.vue?vue&type=script&lang=js"

import "./CartDropdown.vue?vue&type=style&index=0&id=b03a9070&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b03a9070"]])

export default __exports__